import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

// telerik imports
import { ClipboardModule } from '@angular/cdk/clipboard';
import { GridModule } from '@progress/kendo-angular-grid';
import { IconsModule } from '@progress/kendo-angular-icons';
import { ButtonModule } from '@progress/kendo-angular-buttons';
import { LayoutModule, GridLayoutModule, TabStripModule } from '@progress/kendo-angular-layout';
import { TextBoxModule, TextAreaModule, CheckBoxModule } from '@progress/kendo-angular-inputs';
import { DatePickerModule } from '@progress/kendo-angular-dateinputs';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { LabelModule } from '@progress/kendo-angular-label';
import { DialogModule } from '@progress/kendo-angular-dialog';
import { InputsModule } from "@progress/kendo-angular-inputs";
import { NotificationModule } from '@progress/kendo-angular-notification';
import { ScrollViewModule } from '@progress/kendo-angular-scrollview';

import { AuthenticationService } from '@core/services/authentication.serivce';

import { UploadsModule } from '@progress/kendo-angular-upload';
import { SelectFieldComponent } from '../../shared/components/select-field/select-field.component';
import { DetailComponent } from '../../shared/components/detail/detail.component';
import { SearchComponent } from '../../shared/components/search/search.component';
import { LoaderModule } from '@progress/kendo-angular-indicators';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { BundleComponent } from './bundle/bundle.component';
import { BundleListComponent } from './bundle-list/bundle-list.component';
import { BundlesRoutingModule } from './bundles-routing.module';
import { ItemBundleComponent } from './item-bundle/item-bundle.component';
import { BundleService } from './services/bundle.service';
import { EditorModule } from '@progress/kendo-angular-editor';



@NgModule({
  imports: [
    FormsModule,
    ReactiveFormsModule,
    ButtonModule,
    LayoutModule,
    TextBoxModule,
    LoaderModule,
    TextAreaModule,
    CheckBoxModule,
    DatePickerModule,
    UploadsModule,
    LabelModule,
    GridLayoutModule,
    GridModule,
    ScrollViewModule,
    DropDownsModule,
    EditorModule,
    IconsModule,
    NotificationModule,
    DialogModule,
    InputsModule,
    FaIconComponent,
    SelectFieldComponent,
    DetailComponent,
    SearchComponent,
    TabStripModule,
    BundlesRoutingModule
  ],
  declarations: [
    BundleListComponent,
    BundleComponent,
    ItemBundleComponent
  ],
  providers: [AuthenticationService, BundleService]
})
export class BundlesModule { }
